import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Check } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['El sistema completo 7–14–30 explicado sin relleno', 'Checklist diarios para no improvisar', 'Trackers para medir días cumplidos (lo único que importa)', 'Scripts anti-procrastinación para el momento exacto del escape', 'Adaptación por turnos: mañana / tarde / noche', 'Cómo elegir una Meta-ATM: un skill que paga y se practica en 30–40 min', 'Plan de 90 días para sostener el modo LOCK IN sin quemarte'];
  return <section className="py-24 px-6 bg-[#0f0f0f] border-t border-white/5" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <FadeIn data-id="element-3">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-16 text-center tracking-tight" data-id="element-4">
            QUÉ VAS A OBTENER
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-1 gap-6 bg-[#0a0a0a] p-8 md:p-12 border border-white/10 rounded-sm" data-id="element-5">
          {benefits.map((benefit, i) => <FadeIn key={i} delay={0.1 + i * 0.05} direction="left" data-id="element-6">
              <div className="flex items-start gap-4 group" data-id="element-7">
                <div className="mt-1 w-6 h-6 rounded-full bg-blue-600/20 flex items-center justify-center shrink-0 group-hover:bg-blue-600 transition-colors duration-300" data-id="element-8">
                  <Check className="w-4 h-4 text-blue-500 group-hover:text-white transition-colors duration-300" data-id="element-9" />
                </div>
                <p className="text-lg md:text-xl text-gray-300 group-hover:text-white transition-colors duration-300" data-id="element-10">
                  {benefit}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}